
<vg-player (onPlayerReady)="onPlayerReady($event)" [ngClass]="{'hidden': !isPlaying}" [ngClass]="{'vgplayer-home': viewPiP}">
  <div class="loading" *ngIf="!isBuffering">
    <img src="/assets/img/loading_05.gif" class="icon" />
  </div>
  <video #vgHls="vgHls" [vgMedia]="$any(media)" #media [vgHls]="currentStream.source" (onGetBitrates)="sourceBitrates($event)" id="my-video"
    type="video/mp4" crossorigin>
  </video>
</vg-player>
